import { sysURL } from '../constants';
import { httpClient } from './../utils/HttpClient';
import * as M from '../reducers/selectNameOrEmail.reducer';

//redirect to login page

//load Count Summary Data Group ";
export const setSelectNameOrEmailStateToFetching = () => ({
  type: M.SELECT_NAME_OR_EMAIL_FETCHING,
});

export const setSelectNameOrEmailStateToFailed = () => ({
  type: M.SELECT_NAME_OR_EMAIL_FAILED,
});

export const setSelectNameOrEmailStateToSuccess = (payload) => ({
  type: M.SELECT_NAME_OR_EMAIL_SUCCESS,
  payload,
});

export const loadUserName = (search) => {
  let api = 'user/v1/searchName?name=' + search;
  let url = api;
  return async (dispatch, getState) => {
    try {
      dispatch(setSelectNameOrEmailStateToFetching());

      let result = await httpClient.get(url);

      if (result.data.status == true) {
        dispatch(setSelectNameOrEmailStateToSuccess(result.data));
      } else {
        dispatch(setSelectNameOrEmailStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(setSelectNameOrEmailStateToFailed({ data: { message: error } }));
    }
    //console.log(getState().SelectNameOrEmailReducer.result.content);
    return getState().SelectNameOrEmailReducer.result.content;
  };
};
